<div class="d-flex align-items-center px-3 gap-2 chat-panel-hdr">
  <mat-icon class="flex-shrink-0" style="opacity: 0.85">smart_toy</mat-icon>

  @if (agents().length > 1) {
  <mat-select class="agent-select flex-fill" [ngModel]="selectedAgentId()" (ngModelChange)="agentChange.emit($event)" aria-label="Select agent">
    @for (agent of agents(); track agent.id) {
    <mat-option [value]="agent.id">{{ agent.label ?? agent.id }}</mat-option>
    }
  </mat-select>
  } @else {
  <span class="mat-font-title-sm flex-fill text-truncate">{{ title() }}</span>
  } @if (debugMode.isDebugMode()) {
  <button matIconButton matTooltip="Report chat trace" aria-label="Report chat trace" (click)="debugStream.openReportDialog()">
    <mat-icon>flag</mat-icon>
  </button>
  }

  <!-- Settings menu -->
  <button matIconButton #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="settingsMenu" (menuOpened)="onSettingsMenuOpened()" aria-label="Chat settings">
    <mat-icon>settings</mat-icon>
  </button>
  <mat-menu #settingsMenu="matMenu" panelClass="chat-settings-menu">
    <button mat-menu-item (click)="newChatRequested.emit()">
      <mat-icon>add_comment</mat-icon>
      <span>New chat</span>
    </button>

    <mat-divider />
    <div class="px-2 pt-1 pb-1" (click)="$event.stopPropagation()">
      <p class="mat-font-label-sm px-1 mb-1 opacity-75">Recent conversations</p>
      <lib-chat-thread-list (threadSelected)="menuTrigger.closeMenu()" />
    </div>
  </mat-menu>

  @if (showReset()) {
  <button matIconButton aria-label="Reset position and size" matTooltip="Reset position & size" (click)="resetClicked.emit()">
    <mat-icon>fullscreen_exit</mat-icon>
  </button>
  } @if (showMinimize()) {
  <button matIconButton aria-label="Minimize chat" matTooltip="Minimize" (click)="minimizeClicked.emit()">
    <mat-icon>remove</mat-icon>
  </button>
  }
</div>
